<ion-button (click)="openSidebar()" class="ion-float-right toolbar-button" color="transparent">
  <ion-icon slot="icon-only" src="assets/imgs/menu.svg" class="header-text" color="light"></ion-icon>
</ion-button>
